import { motion } from 'framer-motion';
import React, { Fragment } from 'react';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { SvodSource } from '../../../queries/ats/titles/types/sources';
import { isPlayable } from '../../../queries/ats/titles/utils/sources-utils';
import { MoreEpisodesButton } from '../details-button/more-episodes-button';
import { TrailerButton } from '../details-button/trailer-button';
import { WatchFromStartButton } from '../details-button/watch-from-start-button';
import { getProgress } from '../details-call-to-action/utils';
import { FocusedAsset } from '../use-focused-asset';
import { buttonProps } from './secondary-buttons-variants';

interface SvodSecondaryButtonsRowProps {
  asset: Asset;
  focusedAssed: FocusedAsset;
  source: SvodSource;
}

const MotionMoreEpisodesButton = motion(MoreEpisodesButton);
const MotionWatchFromStartButton = motion(WatchFromStartButton);
const MotionTrailerButton = motion(TrailerButton);

export function SvodSecondaryButtonsRow({ asset, focusedAssed, source }: SvodSecondaryButtonsRowProps) {
  const progress = getProgress(source.bookmark, focusedAssed);

  return (
    <Fragment>
      {asset.type === 'episode' && (
        <MotionMoreEpisodesButton {...buttonProps('more-episodes')} asset={asset} source={source} />
      )}
      {progress !== undefined && isPlayable(source) && (
        <MotionWatchFromStartButton {...buttonProps('watch-from-start')} source={source} />
      )}
      {source.hasTrailer && (
        <MotionTrailerButton
          {...buttonProps('trailer')}
          platformTitleId={source.platformTitleId}
          providerIdentifier={source.providerIdentifier}
        />
      )}
    </Fragment>
  );
}
